/* eslint-disable react/jsx-props-no-spreading */
import type { FunctionComponent } from 'react'

import { SvgIcon, SvgIconProps } from '@/tbui'

export const ChevronLeft: FunctionComponent<SvgIconProps> = (svgProps) => (
  <SvgIcon fontSize="10px" {...svgProps}>
    <svg viewBox="0 0 24 24">
      <g>
        <path
          d="M17,23c-0.25586,0-0.51172-0.09766-0.70703-0.29297l-10-10c-0.39062-0.39062-0.39062-1.02344,0-1.41406l10-10
		c0.39062-0.39062,1.02344-0.39062,1.41406,0s0.39062,1.02344,0,1.41406L8.41406,12l9.29297,9.29297
		c0.39062,0.39062,0.39062,1.02344,0,1.41406C17.51172,22.90234,17.25586,23,17,23z"
        />
      </g>
    </svg>
  </SvgIcon>
)

export const DoubleChevronLeft: FunctionComponent<SvgIconProps> = (svgProps) => (
  <SvgIcon fontSize="10px" {...svgProps}>
    <svg viewBox="0 0 24 24">
      <g>
        <path
          d="M10.91016,22c-0.25781,0-0.51465-0.09912-0.71094-0.29639l-8.91016-9c-0.38574-0.38965-0.38574-1.01758,0-1.40723
  l8.91016-9c0.38965-0.3916,1.02246-0.39648,1.41406-0.00684c0.39258,0.38818,0.39648,1.02148,0.00781,1.41406L3.40723,12
  l8.21387,8.29639c0.38867,0.39258,0.38477,1.02588-0.00781,1.41406C11.41895,21.90381,11.16406,22,10.91016,22z"
        />
      </g>
      <g>
        <path
          d="M22,22c-0.25781,0-0.51465-0.09912-0.71094-0.29639l-8.91016-9c-0.38574-0.38965-0.38574-1.01758,0-1.40723l8.91016-9
  c0.38965-0.3916,1.02246-0.39648,1.41406-0.00684c0.39258,0.38818,0.39648,1.02148,0.00781,1.41406L14.49707,12l8.21387,8.29639
  c0.38867,0.39258,0.38477,1.02588-0.00781,1.41406C22.50879,21.90381,22.25391,22,22,22z"
        />
      </g>
    </svg>
  </SvgIcon>
)

export const ChevronRight: FunctionComponent<SvgIconProps> = (svgProps) => (
  <SvgIcon fontSize="10px" {...svgProps}>
    <svg viewBox="0 0 24 24">
      <g>
        <path
          d="M7,23c-0.25586,0-0.51172-0.09766-0.70703-0.29297c-0.39062-0.39062-0.39062-1.02344,0-1.41406L15.58594,12
		L6.29297,2.70703c-0.39062-0.39062-0.39062-1.02344,0-1.41406s1.02344-0.39062,1.41406,0l10,10
		c0.39062,0.39062,0.39062,1.02344,0,1.41406l-10,10C7.51172,22.90234,7.25586,23,7,23z"
        />
      </g>
    </svg>
  </SvgIcon>
)

export const DoubleChevronRight: FunctionComponent<SvgIconProps> = (svgProps) => (
  <SvgIcon fontSize="10px" {...svgProps}>
    <svg viewBox="0 0 24 24">
      <g>
        <path
          d="M13.08984,22c-0.25391,0-0.50879-0.09619-0.70312-0.28955c-0.39258-0.38818-0.39648-1.02148-0.00781-1.41406L20.59277,12
		l-8.21387-8.29639c-0.38867-0.39258-0.38477-1.02588,0.00781-1.41406c0.3916-0.38965,1.02441-0.38477,1.41406,0.00684l8.91016,9
		c0.38574,0.38965,0.38574,1.01758,0,1.40723l-8.91016,9C13.60449,21.90088,13.34766,22,13.08984,22z"
        />
      </g>
      <g>
        <path
          d="M2,22c-0.25391,0-0.50879-0.09619-0.70312-0.28955c-0.39258-0.38818-0.39648-1.02148-0.00781-1.41406L9.50293,12
		L1.28906,3.70361C0.90039,3.31104,0.9043,2.67773,1.29688,2.28955c0.3916-0.38965,1.02441-0.38477,1.41406,0.00684l8.91016,9
		c0.38574,0.38965,0.38574,1.01758,0,1.40723l-8.91016,9C2.51465,21.90088,2.25781,22,2,22z"
        />
      </g>
    </svg>
  </SvgIcon>
)
